module.exports = __webpack_public_path__ + "img/icon4.5e63f5f9.png";